(function () {
  var STORAGE_KEY = 'ou-app-banner-dismissed';
  var initialized = false;

  function getPlatform() {
    var ua = navigator.userAgent || '';
    var platform = navigator.platform || '';
    var maxTouch = navigator.maxTouchPoints || 0;
    var isIOS = /iPhone|iPad|iPod/i.test(ua) || (platform === 'MacIntel' && maxTouch > 1);
    var isAndroid = /Android/i.test(ua);

    if (isIOS) return 'ios';
    if (isAndroid) return 'android';
    return 'other';
  }

  function closestSection(el) {
    return el.closest('.app-banner-section') || el.closest('.shopify-section');
  }

  function activeBanner() {
    var banner = document.querySelector('[data-app-banner]:not([data-placement="page"])');
    if (!banner || banner.hidden || banner.classList.contains('is-dismissed')) return null;

    var section = closestSection(banner);
    if (section && section.classList.contains('is-dismissed')) return null;

    return banner;
  }

  function syncBannerOffset() {
    var banner = activeBanner();
    var height = banner ? banner.offsetHeight : 0;

    document.documentElement.style.setProperty('--app-banner-height', height + 'px');
    document.documentElement.classList.toggle('has-app-banner', height > 0);
  }

  function dismiss(banner) {
    if (!banner) return;

    banner.classList.add('is-dismissed');
    banner.setAttribute('hidden', '');
    banner.style.display = 'none';

    var section = closestSection(banner);
    if (section) {
      section.classList.add('is-dismissed');
      section.style.display = 'none';
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}

    syncBannerOffset();
  }

  function applyPlatform() {
    document.querySelectorAll('[data-app-banner]').forEach(function (banner) {
      try {
        if (banner.hasAttribute('data-dismissible') && sessionStorage.getItem(STORAGE_KEY) === '1') {
          dismiss(banner);
          return;
        }
      } catch (e) {}

      banner.setAttribute('data-os', getPlatform());
    });
  }

  function onCloseClick(event) {
    var closeButton = event.target.closest('[data-app-banner-close]');
    if (!closeButton) return;

    event.preventDefault();
    event.stopPropagation();

    var banner = closeButton.closest('[data-app-banner]');
    dismiss(banner);
  }

  function init() {
    if (initialized) return;
    initialized = true;
    applyPlatform();
    syncBannerOffset();
    document.addEventListener('click', onCloseClick, true);
    window.addEventListener('resize', syncBannerOffset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
